import { format } from 'date-fns';

type Range = { departureDate?: Date; returnDate?: Date };

const getButtonForDate = (date?: Date): HTMLButtonElement | null => {
  if (!date || Number.isNaN(date.getTime())) {
    return null;
  }

  return document.querySelector<HTMLButtonElement>(
    `.rdp-day[data-day="${format(date, 'yyyy-MM-dd')}"] button:not([disabled]`,
  );
};

export const getFirstAndLastSelectableDateButtons = ({
  departureDate,
  returnDate,
}: Range): {
  departureDate: HTMLButtonElement | null;
  returnDate: HTMLButtonElement | null;
} => {
  const firstButton = document.querySelector<HTMLButtonElement>(
    '.rdp-day[data-today="true"] button',
  );

  const departureDateButton = getButtonForDate(departureDate);
  const returnDateButton = getButtonForDate(returnDate);

  return {
    departureDate: departureDateButton || firstButton,
    returnDate: returnDateButton || departureDateButton || firstButton,
  };
};
